module.exports = __webpack_public_path__ + "static/media/icon-agep-open-book.709a2a85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/icon-agep-open-book.svg
// module id = 649
// module chunks = 0